import React, { useState } from "react";
import { Upload, Spin, message, Icon, Progress } from "antd";

import BraftEditor, { ControlType } from "braft-editor";
// @ts-ignore
import { ContentUtils } from "braft-utils";
import "braft-editor/dist/index.css";
import moment from "moment";

import { getQiniuUploadToken, getName } from "API";
import { RcFile } from "antd/lib/upload";

import Style from "../questionItem.module.scss";
import { checkCourseWareStr } from "../../../../../Utils/filter";

const uploadUrl = "https://up-z1.qiniup.com";
const uploadName = "file";
// const uploadUrl = "/student/file/upload"
// const uploadName = "upload"
const downloadUrl = "https://niu.edufe.com.cn/";

interface EditorProps {
    content: string;
    answerId: number;
    canPastedText?: boolean;
    onChange: (answerId: number, value: string) => void;
}

const Editor: React.FC<EditorProps> = ({
    content,
    answerId,
    canPastedText = true,
    onChange
}) => {
    const [editorState, setEditorState] = useState(
        BraftEditor.createEditorState(content)
    );
    const [percent, setPercent] = useState(0);
    const [token, setToken] = useState("");

    const controls: ControlType[] = [
        "bold",
        "italic",
        "underline",
        "separator",
        "link",
        "separator",
        "emoji"
    ];

    const beforeUpload = async (file: RcFile, fileList: RcFile[]) => {
        if (checkCourseWareStr(file).next) {
            await getQiniuUploadToken()
                .then(res => {
                    setToken(res.message);
                    return Promise.resolve(file);
                })
                .catch(() => {
                    return Promise.reject();
                });
        } else {
            message.error(checkCourseWareStr(file).msg);
            return Promise.reject(file);
        }
    };

    const handleUploadFile = async (res: any, type: "file" | "image") => {
        if (res.file.status === "uploading") {
            setPercent(Math.floor(res.file.percent));
        }
        if (res.file.status === "error") {
            setPercent(0);
            message.error(
                res.file.response && res.file.response.message
                    ? res.file.response.message
                    : "上传失败！"
            );
        }
        if (res.file.status === "done") {
            setPercent(0);
            // const link = res.file.response.message
            const link = await getFileName(
                res.file.response.key,
                res.file.name
            );
            let state;
            if (type === "file") {
                state = ContentUtils.insertHTML(
                    editorState,
                    `<a target="_blank" href='${link}'>${res.file.name}</a>`
                );
            }
            if (type === "image") {
                state = ContentUtils.insertMedias(editorState, [
                    { type: "IMAGE", url: link }
                ]);
            }
            setEditorState(state);
            handleBlur(answerId, state.toHTML());
        }
    };

    const getFileName = async (key: string, fileName: string) => {
        const fileNameArray = fileName.split(".");
        const { name } = await getName();
        const studentNo = localStorage.getItem("user");
        return `${downloadUrl}${key}?attname=${name}${studentNo}_${moment().format(
            "YYYYMMDDHHmmss"
        )}.${fileNameArray[fileNameArray.length - 1]}`;
    };

    const extendControls: any = [
        "separator",
        {
            key: "fileUpload",
            type: "component",
            component: (
                <Upload
                    // accept="*/*"
                    action={uploadUrl}
                    data={{ token }}
                    name={uploadName}
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    onChange={async res => await handleUploadFile(res, "file")}>
                    <button
                        type="button"
                        className="control-item button upload-button"
                        data-title="插入附件">
                        <Icon type="paper-clip" />
                    </button>
                </Upload>
            )
        },
        {
            key: "ImageUpload",
            type: "component",
            component: (
                <Upload
                    accept="image/png,image/jpeg,image/gif,image/webp,image/apng,image/svg"
                    action={uploadUrl}
                    data={{ token }}
                    name={uploadName}
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    onChange={async res =>
                        await handleUploadFile(res, "image")
                    }>
                    <button
                        type="button"
                        className="control-item button upload-button"
                        data-title="插入图片">
                        <Icon type="picture" />
                    </button>
                </Upload>
            )
        }
    ];

    const handleBlur = (answerId: number, value: string) => {
        if (value === "<p></p>") value = "";
        onChange(answerId, value);
    };

    return (
        <Spin
            size="large"
            indicator={
                <Progress
                    className={Style.loading}
                    type="circle"
                    percent={percent}
                />
            }
            spinning={percent > 0 && percent < 100}>
            <BraftEditor
                key={answerId}
                value={editorState}
                controls={controls}
                onChange={setEditorState}
                draftProps={{ handlePastedText: () => !canPastedText }}
                onBlur={(state: any) => handleBlur(answerId, state.toHTML())}
                contentStyle={{
                    height: 210,
                    boxShadow: "inset 0 1px 3px rgba(0,0,0,.1)"
                }}
                className={Style.editor}
                extendControls={extendControls}
            />
        </Spin>
    );
};

interface ITextEditorProps {
    list: any[];
    homeworkState: number;
    canPastedText: boolean;
    onChange: (answerId: number, value: string) => void;
    comment?: string | null | undefined;
}

export const TextEditors = ({
    list,
    homeworkState,
    canPastedText,
    onChange,
    comment
}: ITextEditorProps) => {
    return (
        <>
            {list.map(item =>
                homeworkState === 1 ? (
                    <Editor
                        canPastedText={canPastedText}
                        key={item.answerId}
                        answerId={item.answerId}
                        content={item.stuAnswer}
                        onChange={onChange}
                    />
                ) : (
                    <div key={item.answerId}>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: item.stuAnswer
                            }}
                        />
                        {item.content && (
                            <div className={Style.borderTop}>
                                正确答案：{" "}
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: item.content
                                    }}
                                />
                            </div>
                        )}
                        {!!comment && (
                            <div
                                className={`${Style.borderTop} ${Style.comment}`}>
                                <span>老师评语：</span>
                                {comment}
                            </div>
                        )}
                    </div>
                )
            )}
        </>
    );
};
